module.exports = __webpack_public_path__ + "img/home-section-arrows.d763697.png";